import React from "react";

import { BettingType } from ".";

export function BettingTypeGroupBody(props: {
	isExpanded?: boolean;
	group: { bettingTypes: Parameters<typeof BettingType>[0]["bettingType"][] };
	isFavorite?: boolean;
}) {
	const { isExpanded, group, isFavorite } = props;

	if (!isExpanded) {
		return null;
	}

	return (
		<div className="offer__body offer--additional__body">
			{group.bettingTypes.map((bt) => (
				<BettingType
					key={bt.id}
					bettingType={bt}
					isFavorite={isFavorite}
				/>
			))}
		</div>
	);
}
